import { useParams } from "react-router-dom";
import { s2ConventionId } from "../util/type-conversion";

/**
 * @returns {import("@seabrookstudios/pitch2table-core").ConventionId}
 */
export const useConventionIdFromRoute = () => {
  return s2ConventionId(useParams().conventionId || "");
};
